import { Link2 } from "lucide-react";
import { Link } from "react-router-dom";

export const PARENT_META = {
  edm_campaign: { label: "Direct Campaign", href: (id) => `/campaigns/direct?open=${id}` },
  agent_campaign: { label: "Agent Campaign", href: (id) => `/campaigns/agent?open=${id}` },
  collaboration: { label: "Collaboration", href: (id) => `/collaborations?open=${id}` },
  print_order: { label: "Print Order", href: (id) => `/print-orders?open=${id}` },
  voucher: { label: "Prize Voucher", href: (id) => `/prize-vouchers?open=${id}` },
  opportunity: { label: "Opportunity", href: (id) => `/opportunities/${id}` },
};

export function ParentChip({ task, onNavigate, className = "" }) {
  const m = PARENT_META[task?.parent_type];
  if (!m || !task.parent_id) return null;
  return (
    <Link to={m.href(task.parent_id)} onClick={(e) => { e.stopPropagation(); onNavigate?.(); }} data-testid={`task-parent-link-${task.id || "new"}`}
      className={`inline-flex max-w-full items-center gap-1 rounded-full bg-violet-50 px-2 py-0.5 text-[11px] font-medium text-violet-700 hover:bg-violet-100 ${className}`}>
      <Link2 className="h-3 w-3 shrink-0" /><span className="truncate">{m.label}{task.parent_label ? ` · ${task.parent_label}` : ""}</span>
    </Link>
  );
}
